import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number;
    const cycle = () => {
      setIndex(i => (i + 1) % recentBuyers.length);
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), 5000);
    };
    const first = window.setTimeout(() => {
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), 5000);
    }, 6000);
    const interval = window.setInterval(cycle, 14000);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  const minutesAgo = index % 9 + 2;
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:left-5 sm:right-auto" aria-live="polite" data-id="element-228" data-mp="16462ufgs8780">
      <AnimatePresence data-id="element-229" data-mp="1fvspd7yklsq2">
        {show && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex max-w-sm items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_-10px_rgba(29,35,82,0.45)] ring-1 ring-lavender-deep relative" data-id="element-230" data-mp="1fv97fr8x74c1">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-plum" data-id="element-231" data-mp="s5euzasijhsb">
              <ShoppingBagIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-232" data-mp="28j4z2hjmu61y" />
            </span>
            <div className="text-sm leading-snug" data-id="element-233" data-mp="23kleakgrz0b6">
              <p className="text-ink" data-id="element-234" data-mp="2aol3ga6w861o">
                <strong data-id="element-235" data-mp="2anjlrmvdglaz">{buyer.name}</strong> from {buyer.country} {buyer.flag}
              </p>
              <p className="text-muted" data-id="element-236" data-mp="2fmmr78f9ktjh">just bought <strong className="text-plum" data-id="element-237" data-mp="2fpqzagvuo9ff">The Peaceful Night Method™</strong></p>
              <p className="mt-0.5 text-xs text-muted" data-id="element-238" data-mp="2knah1qrrb4c4">{minutesAgo} minutes ago</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="absolute right-2 top-2 rounded-full p-1 text-muted hover:text-ink" data-id="element-239" data-mp="2plbyy8dg4xm0">
              <XIcon className="h-4 w-4" data-id="element-240" data-mp="21vpy7ghfeabw" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}